import { FC } from "react";
import dayjs from "dayjs";
import { Layout, Typography } from "components";

const Footer: FC<{ appVersion: string | null }> = ({ appVersion }) => {
  return (
    <Layout.Footer style={{ textAlign: "center" }}>
      <Typography.Text strong>MyCorpManager - Client Portal</Typography.Text>
      &nbsp;
      <Typography.Text>©{dayjs().format("YYYY")}</Typography.Text>
      &nbsp; - &nbsp;
      <small>Built by</small>
      &nbsp;
      <Typography.Link href="https://deliostech.com" target="_blank">
        Delios Technology Inc
      </Typography.Link>
      <br />
      {appVersion && (
        <Typography.Text strong>
          <small>Version {appVersion}</small>
        </Typography.Text>
      )}
    </Layout.Footer>
  );
};

export default Footer;
